
// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import cx from 'classnames';
import TextField from '../../../../../common/components/c_TextField';
import ProgressComponent from '../../../../../common/components/C_ProgressComponent';

// class name
// import cx from 'classnames';

@connect(store => ({
  labels: _.get(store.labels, 'Application', {}),
}), null, null, {withRef: true})
export default class Submit extends ProgressComponent {
  static propTypes = {
    user: PropTypes.object.isRequired,
    workExperiences: PropTypes.object.isRequired,
    profileId: PropTypes.number.isRequired,
    tempState: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired,
    updateTempState: PropTypes.func.isRequired,
    model: PropTypes.string.isRequired,
    formSections: PropTypes.object,
  }

  constructor(props, context) {
    super(props, context);
  }

  state = {
    showSubscribeError: false
  };

  expectedSignature() {
    const signature = `${this.props.user.firstName} ${this.props.user.middleName} ${this.props.user.lastName}`;

    // remove multiple consecutive spaces in case middleName is null/blank
    return signature.replace(/\s+/g, ' ');
  }

  handleChange(event) {
    if(this.expectedSignature() === String(event.target.value)) {
      this.setState({showSubscribeError:false});
      this.props.updateTempState(this.props.model, 'dateAuthorized', event, (new Date()).toDateString());
    }else{
      this.setState({showSubscribeError:true});
      this.props.updateTempState(this.props.model, 'dateAuthorized', event, '');
    }
  }

  closeModal = () => {
    this.setState({showSubscribeError:false});
  }

  // Override ValidatedForm.validateForm()
  validateForm() {
    return !_.isNil(_.get(this.props.tempState, 'profile', {}).dateAuthorized);
  }

  render() {
    const requiredSections = {
      Profile: false,
      Preferences: false,
      Experience: false,
      Skills: false,
      'Summary of Skills': false,
      Background: false,
    };
    const incompleteSections = _.merge(
      {},
      requiredSections,
      _.omit(this.props.formSections, ['Welcome', 'Documents', 'Instructions', 'Submit', 'Assessments'])
    );

    const incompleteErrorArray = _.map(
      _.pickBy(incompleteSections, (value) => !value),
      (value, sectionName) => sectionName
    );

    return (
      <div className={cx('application-section-container clearfix authorize-and-submit')}>
        <div
          className='form-heading'
          data-id='Authorize & Submit title'>
          Authorize & Submit
        </div>
        <div className='callout'>
          {_.get(this.props.labels, 'authorizationIntro')}
        </div>
        <div className='form-text claim-text' dangerouslySetInnerHTML={{__html: _.get(this.props.labels, 'authorizationTerms')}}>
        </div>
        <div>
          {
            incompleteErrorArray.length ?
            <div className='incomplete-sections'>
              The following section(s) have not been completed. Please complete in order to submit.
              <ul className='sections-list'>
                {
                  incompleteErrorArray.map((sectionName, idx) => <li key={idx}>{sectionName}</li>)
                }
              </ul>
            </div>
            : null
          }
          {
            <div>
              <TextField
                data-id='signature'
                disabled={!_.isNil(this.props.profile.dateAuthorized)}
                defaultValue={_.isNil(this.props.profile.dateAuthorized) ? '' : this.expectedSignature()}
                onBlur = {this.handleChange.bind(this)}
                floatingLabelText = 'First Name Middle Name and Last Name'
              />
                {!this.state.showSubscribeError ?
                  <span className='user-name'>({this.expectedSignature()})</span>
                : null}
                {this.state.showSubscribeError ?
                  <span className='user-name error'>({this.expectedSignature()}) Please sign with the name provided.</span>
                : null}
            </div>
          }
          <TextField
            data-id='date signed'
            disabled={!_.isNil(this.props.profile.dateAuthorized)}
            defaultValue = {_.isNil(this.props.profile.dateAuthorized) ? new Date().toDateString() : new Date(this.props.profile.dateAuthorized).toDateString()}
            floatingLabelText = 'Date Signed'
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/f_Application/r_ApplicationForm/c_Submit/index.js